// ** React Imports
import { lazy } from 'react'
import { Navigate } from 'react-router-dom'

const User = lazy(() => import('../../views/users'))
const Profile = lazy(() => import('../../views/profile'))
const Merk = lazy(() => import('../../views/merk'))
const Engine = lazy(() => import('../../views/engine'))
const Type = lazy(() => import('../../views/type'))
const Category = lazy(() => import('../../views/category'))
const Document = lazy(() => import('../../views/document'))
const Aircraft = lazy(() => import('../../views/aircrafts'))
const Productivity = lazy(() => import('../../views/productivity'))
const Dashboard = lazy(() => import('../../views/dashboard'))

const AppRoutes = [
  {
    path: '/dashboard',
    element: <Dashboard />,
    meta: {
      action: 'read',
      resource: 'dashboard'
    }
  },
  {
    element: <Merk />,
    path: '/merk',
    meta: {
      action: 'read',
      resource: 'master'
    }
  },
  {
    element: <Engine />,
    path: '/engine',
    meta: {
      action: 'read',
      resource: 'master'
    }
  },
  {
    element: <Type />,
    path: '/type',
    meta: {
      action: 'read',
      resource: 'master'
    }
  },
  {
    element: <Category />,
    path: '/category',
    meta: {
      action: 'read',
      resource: 'master'
    }
  },
  {
    element: <Document />,
    path: '/documents',
    meta: {
      action: 'read',
      resource: 'master'
    }
  },
  {
    element: <Aircraft />,
    path: '/aircrafts',
    meta: {
      action: 'read',
      resource: 'aircrafts'
    }
  },
  {
    element: <Productivity />,
    path: '/productivity',
    meta: {
      action: 'read',
      resource: 'productivity'
    }
  },
  {
    element: <User />,
    path: '/users',
    meta: {
      action: 'read',
      resource: 'manageuser'
    }
  },
  {
    element: <Profile />,
    path: '/profile',
    meta: {
      action: 'read',
      resource: 'profile'
    }
  },
  {
    path: '/apps/user/view',
    meta: {
      action: 'read',
      resource: 'profile'
    },
    element: <Navigate to='/apps/user/view/1' />
  }
]

export default AppRoutes
